import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import SubscriptionPage from './pages/SubscriptionPage';
import BindCardPage from './pages/BindCardPage';
import ManageCardsPage from './pages/ManageCardsPage';
import MkpuPage from './pages/MkpuPage';
import PaymentHistoryPage from './pages/PaymentHistoryPage';
import DevToolsPage from './pages/DevToolsPage';
import RedeemPage from './pages/RedeemPage';
import AdminPage from './pages/AdminPage';
import Header from './components/Header';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import AuthModal from './components/AuthModal';
import './index.css';

const AppContent = () => {
    const { token } = useAuth();

    if (!token) {
        return <AuthModal />;
    }

    return (
        <Router>
            <Header />
            <main>
                <Routes>
                    <Route path="/" element={<SubscriptionPage />} />
                    <Route path="/subscriptions" element={<SubscriptionPage />} />
                    <Route path="/redeem" element={<RedeemPage />} />
                    <Route path="/bind-card" element={<BindCardPage />} />
                    <Route path="/manage-cards" element={<ManageCardsPage />} />
                    <Route path="/mkpu" element={<MkpuPage />} /> 
                    <Route path="/payment-history" element={<PaymentHistoryPage />} /> 
                    <Route path="/dev-tools" element={<DevToolsPage />} /> 
                    <Route path="/admin" element={<AdminPage />} />
                </Routes>
            </main>
        </Router>
    );
}

function App() {
    return (
        <AuthProvider>
            <AppContent />
        </AuthProvider>
    );
}

export default App;